import store from '@/packages/vuex'
import { createNamespacedHelpers } from 'vuex'
import OrdersOem from './index.js'

if (!store?.state?.['OrdersOem']) {
	store.registerModule('OrdersOem', OrdersOem)
}

export const { mapActions, mapGetters, mapMutations, mapState } = createNamespacedHelpers('OrdersOem')
